export const PRIVACY_POLICY_URL = 'https://www.gigamaisfibra.com.br/politica-de-privacidade/'

export const TERMS_OF_USAGE = 'https://www.gigamaisfibra.com.br/termos-de-uso/'

export const INFORMATION_SECURITY = 'https://www.gigamaisfibra.com.br/seguranca-da-informacao/'

export const CONTRACTS_AND_REGULATIONS_URL =
  'https://www.gigamaisfibra.com.br/contratos-e-regulamentos/'
